/**
 * CategoryMetricChart export with lazy loading
 *
 * Lazy loads the Victory-based metric chart to reduce initial bundle size.
 */

/* eslint-disable component-structure/enforce-component-structure -- Intentional lazy wrapper pattern */
import React, { ComponentProps, lazy, memo, Suspense } from "react";

import ChartSkeleton from "@/components/molecules/ChartSkeleton";

const CategoryMetricChartContainer = lazy(
  () => import("./CategoryMetricChartContainer")
);

/** Props for the lazy-loaded CategoryMetricChart component */
type CategoryMetricChartProps = ComponentProps<
  typeof CategoryMetricChartContainer
>;

/**
 * Lazy-loaded CategoryMetricChart wrapper with loading fallback.
 * @param props - CategoryMetricChartContainer props
 */
const LazyCategoryMetricChart = memo((props: CategoryMetricChartProps) => (
  <Suspense fallback={<ChartSkeleton />}>
    <CategoryMetricChartContainer {...props} />
  </Suspense>
));

LazyCategoryMetricChart.displayName = "LazyCategoryMetricChart";

export default LazyCategoryMetricChart;
export type { CategoryMetricChartProps } from "./CategoryMetricChartContainer";
/* eslint-enable component-structure/enforce-component-structure -- Re-enable after lazy wrapper */
